// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cFDK","col":"styles_col__3kMZL"};